/**
 * Application Constants
 * Centralized constants for the entire application
 */

// Layout Constants
export const LAYOUT = {
  TOP_BAR_HEIGHT: 64,
  SIDE_NAV_WIDTH: 260,
  NAVBAR_HEIGHT: 60,
  SIDENAV_COMPACT_WIDTH: 80,
  CONTAINED_LAYOUT_WIDTH: 1200,
};

// Permission Constants
export const PERMISSIONS = {
  ROLE_PERMISSION: 'Role',
  PERMISSION: 'Permission',
  USERS: 'Users',
  WORKLOCATION: 'WORKLOCATION',
  CATEGORY: 'Category',
  UNIT: 'Unit',
  PRODUCT: 'Product',
  SVV: 'SVV',
  LEAVE_POLICY: 'LEAVE_POLICY',
  HIERARCHY: 'HIERARCHY',
  PENDING_LEAVE_REQUEST: 'PENDING_LEAVE_REQUEST',
  HRREPORT: 'HRREPORT',
  PROJECTMANAGMENT: 'PROJECTMANAGMENT',
  CLIENTMANAGMENT: 'CLIENTMANAGMENT',
  TASKLIST: 'TASKLIST',
  NEWTASK: 'NEWTASK',
  PROJECTTASK: 'PROJECTTASK',
  ADDPROJECT: 'ADDPROJECT',
  PROJECTLIST: 'PROJECTLIST',
  CHAT: 'CHAT',
};

// Color Constants
export const COLORS = {
  CODE: [
    '#C0C0C0',
    '#808000',
    '#008080',
    '#800080',
    '#7FFFD4',
    '#FFA500',
    '#00FFFF',
    '#FFC0CB',
    '#1589FF',
    '#38ACEC',
    '#50C878',
    '#6CC417',
    '#C2B280',
    '#FFFFF0',
  ],
};

// Leave Types
export const LEAVE_TYPES = [
  { label: 'Paid', value: 'paid' },
  { label: 'Unpaid', value: 'un-paid' },
];

// Leave Days
export const LEAVE_DAYS = [
  { label: 'Half Day', value: 'halfDay' },
  { label: 'Full Day', value: 'full-day' },
];

// Export all constants as default
export default {
  LAYOUT,
  PERMISSIONS,
  COLORS,
  LEAVE_TYPES,
  LEAVE_DAYS,
};


export const STATUSCODE = {
  approved : "#6CC417",
  pending : "#FFA500",
  rejected : "#FF0000",
  cancelled : "#808080",
};